import { render } from "./HeroiconsOutlineTerminal.vue?vue&type=template&id=7dcaa2c4"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTerminal.vue"]])

export default __exports__